import * as React from 'react';
export var IconTooltip = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#3471b8' : _b;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 15, viewBox: "0 0 20 20" },
        React.createElement("path", { id: "Path_1308", "data-name": "Path 1308", d: "M11,9h2V7H11m1,13a8,8,0,1,1,8-8,8.011,8.011,0,0,1-8,8M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2M11,17h2V11H11Z", transform: "translate(-2 -2)", fill: fill })));
};
//# sourceMappingURL=IconTooltip.js.map